import { Container, Row, Col, Form, Modal, Button } from "react-bootstrap";
import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faSquareEnvelope,
  faSquarePhone,
} from "@fortawesome/free-solid-svg-icons";
import { faFacebookMessenger } from "@fortawesome/free-brands-svg-icons";
import emailjs from "@emailjs/browser";
import ReCAPTCHA from "react-google-recaptcha";
import { Helmet } from "react-helmet";

const Contact = () => {
  const windowHeight = window.innerHeight;
  const form = useRef();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showModalCaptcha, setShowModalCaptcha] = useState(false);
  const [isVerified, setIsVerified] = useState(false);

  const onRecaptchaChange = (value) => {
    setIsVerified(true);
  };

  const handlePhoneNumberChange = (event) => {
    let input = event.target.value.replace(/\D/g, "");
    let formatted = "";
    for (let i = 0; i < input.length; i++) {
      if (i === 3 || i === 6) {
        formatted += "-";
      }
      formatted += input[i];
    }
    setPhoneNumber(formatted);
  };

  const sendEmail = (e) => {
    e.preventDefault();

    if (!form.current.checkValidity()) {
      form.current.reportValidity();
      return;
    }

    if (!isVerified) {
      setShowModalCaptcha(true);
      return;
    }

    emailjs
      .sendForm(
        "anten-sat",
        "template_lqpf9zk",
        form.current,
        "XakLbWZ6TL4Nlcunh"
      )
      .then(
        (result) => {
          console.log(result.text);
          setShowModal(true);
          form.current.reset();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  const handleClose = () => setShowModal(false);
  const handleCloseCaptcha = () => setShowModalCaptcha(false);

  useEffect(() => {
    const reveal = (className) => {
      var reveals = document.querySelectorAll(className);

      for (var i = 0; i < reveals.length; i++) {
        var elementTop = reveals[i].getBoundingClientRect().top;
        var elementVisible = 150;

        if (elementTop < windowHeight - elementVisible) {
          reveals[i].classList.add("active");
        } else {
          reveals[i].classList.remove("active");
        }
      }
    };

    window.addEventListener("scroll", () => {
      reveal(".reveal");
      reveal(".reveal2");
      reveal(".reveal3");
      reveal(".reveal4");
    });

    reveal(".reveal");
    reveal(".reveal2");
    reveal(".reveal3");
    reveal(".reveal4");

    return () => {
      window.removeEventListener("scroll", () => {
        reveal(".reveal");
        reveal(".reveal2");
        reveal(".reveal3");
        reveal(".reveal4");
      });
    };
  }, [windowHeight]);

  return (
    <>
      <Helmet>
        <title>Kontakt | Anten-Sat</title>
        <meta
          name="description"
          content="Skontaktuj się z nami! ANTEN-SAT oferuje montaż i ustawianie anten w Częstochowie i okolicach."
        />
        <link rel="canonical" href="https://antensat.pl/contact" />
      </Helmet>

      <Container fluid className="hero">
        <Row className="p-4">
          <h1 className="reveal2 pb-2">GDZIE NAS ZNAJDZIESZ?</h1>
          <div className="d-flex align-items-center reveal4">
            <FontAwesomeIcon
              icon={faLocationDot}
              className="location-dot me-2"
            />
            <span className="address">42-274, Konopiska, ul. Stawowa 5</span>
          </div>
        </Row>
        <hr className="custom-hr"></hr>
        <Row className="p-4">
          <h1 className="reveal">SKONTAKTUJ SIĘ Z NAMI</h1>
          <Row>
            <p className="reveal">Zadzwoń na jeden z podanych numerów:</p>
            <Col md={6} className="reveal2">
              <div className="d-flex align-items-center">
                <Link to="tel:889389818">
                  <FontAwesomeIcon
                    icon={faSquarePhone}
                    className="contact-icon"
                  />
                </Link>
                <h5 className="mx-3">889 389 818</h5>
              </div>
            </Col>
            <Col md={6} className="reveal2">
              <div className="d-flex align-items-center">
                <Link to="tel:343282995">
                  <FontAwesomeIcon
                    icon={faSquarePhone}
                    className="contact-icon"
                  />
                </Link>
                <h5 className="mx-3">34 328 29 95</h5>
              </div>
            </Col>
            <Col md={12} className="mt-5 reveal2">
              <p>Napisz wiadomość e-mail:</p>
              <div className="d-flex align-items-center">
                <Link to="mailto:antensat.kontakt@gmail.com">
                  <FontAwesomeIcon
                    icon={faSquareEnvelope}
                    className="contact-icon"
                  />
                </Link>
                <h5 className="mx-3">antensat.kontakt@gmail.com</h5>
              </div>
            </Col>
            <Col md={6} className="mt-5 reveal2">
              <p>Napisz wiadomość Messenger: </p>
              <div className="d-flex align-items-center">
                <Link to="https://m.me/antensatpl" target="_blank">
                  <FontAwesomeIcon
                    icon={faFacebookMessenger}
                    className="contact-icon"
                  />
                </Link>
                <h5 className="mx-3">Messenger</h5>
              </div>
            </Col>
            <Col md={6} className="mt-5 text-center">
              <p className="click-me reveal3">Kliknij na jedną z ikon!</p>
            </Col>
          </Row>
        </Row>
        <hr className="custom-hr" />

        <Form ref={form} onSubmit={sendEmail}>
          <Row className="p-4">
            <Col md={7}>
              <h1>SKORZYSTAJ Z FORMULARZA KONTAKTOWEGO</h1>

              {/* Modal dla potwierdzenia wysłania wiadomości */}
              <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                  <Modal.Title>Wiadomość została wysłana</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  Twoja wiadomość została pomyślnie wysłana!
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                    ZAMKNIJ
                  </Button>
                </Modal.Footer>
              </Modal>

              {/* Modal dla reCAPTCHA */}
              <Modal show={showModalCaptcha} onHide={handleCloseCaptcha}>
                <Modal.Header closeButton>
                  <Modal.Title>Potwierdź, że nie jesteś robotem</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  Aby poprawnie wysłać wiadomość musisz potwierdzić, że nie
                  jesteś robotem na dole formularza.
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCloseCaptcha}>
                    ZAMKNIJ
                  </Button>
                </Modal.Footer>
              </Modal>

              {/* Pola formularza */}
              <Row className="mt-4">
                <Col xs={6}>
                  <Form.Group className="form-input">
                    <Form.Label>IMIĘ</Form.Label>
                    <Form.Control
                      type="text"
                      name="first_name"
                      required
                      pattern="[a-zA-ZżźćńółęąśŻŹĆĄŚĘŁÓŃ]{3,15}"
                      placeholder=""
                    />
                  </Form.Group>
                </Col>
                <Col xs={6}>
                  <Form.Group className="form-input">
                    <Form.Label>NAZWISKO</Form.Label>
                    <Form.Control
                      type="text"
                      name="last_name"
                      required
                      pattern="[a-zA-ZżźćńółęąśŻŹĆĄŚĘŁÓŃ]{3,15}"
                      placeholder=""
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12} className="mt-3">
                  <Form.Group className="form-input">
                    <Form.Label>E-MAIL</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      required
                      placeholder=""
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} className="mt-3">
                  <Form.Group className="form-input">
                    <Form.Label>NUMER TELEFONU</Form.Label>
                    <Form.Control
                      type="tel"
                      name="phone_number"
                      pattern="[0-9]{3}-[0-9]{3}-[0-9]{3}"
                      maxLength="11"
                      value={phoneNumber}
                      onChange={handlePhoneNumberChange}
                      required
                      placeholder=""
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} className="mt-3">
                  <Form.Group className="form-input">
                    <Form.Label>WIADOMOŚĆ</Form.Label>
                    <Form.Control
                      as="textarea"
                      name="message"
                      rows={6}
                      required
                      minLength="20"
                      className="mb-3"
                    ></Form.Control>
                  </Form.Group>
                </Col>
              </Row>
            </Col>
            <Col md={5}>
              <p>
                W odpowiednich polach formularza umieść swoje dane kontaktowe.
                Następnie w treści wiadomości umieść wszystkie informacje
                dotyczące Twojego pytania. Jeśli pytanie dotyczy np. instalacji
                antenowej, możesz tam także umieścić swój adres. Następnie
                zaakceptuj warunki przetwarzania Twoich danych, oraz potwierdź,
                że nie jesteś robotem i wyślij wiadomość. <br />
                <br />
                <b>Postaramy się odpowiedzieć jak najszybciej!</b>
              </p>
              <div className="d-flex align-items-center gap-3">
                <Form.Check type="switch" id="custom-switch" required />
                <p className="small">
                  Wypełnienie formularza oznacza, że podane w nim dane osobowe
                  będą przetwarzane w celu przesłania oferty oraz kontaktu w jej
                  sprawie.{" "}
                  <Link to="/term">
                    Dowiedz się kto i jak przetwarza Twoje dane.
                  </Link>
                </p>
              </div>
              <div className="text-center">
                <div className="d-flex justify-content-center">
                  <ReCAPTCHA
                    sitekey="6Lc6IeEqAAAAAKxlXKMPeR2LqcAvgMCI3QyaIOBG"
                    onChange={onRecaptchaChange}
                    theme="dark" // Dark mode
                  />
                </div>
                <br />
                <button type="submit" className="mt-3 button-submit">
                  WYŚLIJ
                </button>
              </div>
            </Col>
          </Row>
        </Form>
        <hr className="custom-hr" />
      </Container>
    </>
  );
};

export default Contact;
//
